// src/components/HeroSection.js
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import cover from '../../assets/alaafaq1.jpg'
import "./HeroSection.css"
const HeroSection = () => {
  return (
<Container 
  fluid 
  className="hero-section mb-5" 
  // style={{ background: `url(${cover}) no-repeat ` }}
>
  <Row 
    className="align-items-center h-100" 
  >
    <img src={cover}alt=''className='h-100 w-100'style={{objectFit:"fill"}}/>
  </Row>
</Container>

  );
};

export default HeroSection;
